import ReactTooltip from 'react-tooltip';
import { IoInformationCircleSharp } from 'react-icons/io5';

const Counter = ({ passengerDetails, setPassengerDetails, carDetails }) => {
  const updateCounter = (key: string, value: any) => {
    setPassengerDetails({
      ...passengerDetails,
      [key]: value,
    });
  };

  console.log('hello passenger', passengerDetails);

  return (
    <div className="counter-wrapper">
      <ReactTooltip place="top" />

      <div className="counter-container">
        <label className="counter-label">
          No. of Adults{' '}
          <div>
            <span data-tip="Seats needed for passengers aged 12 and above.">
              <IoInformationCircleSharp />
            </span>
            <ReactTooltip />
          </div>
        </label>

        <NumberAdjuster
          currentCounterValue={passengerDetails?.number_of_passengers ?? 0}
          updateCounter={updateCounter}
          minValue={1}
          maxValue={carDetails?.passengers ?? 0}
          flag={`number_of_passengers`}
        />
      </div>

      <div className="counter-container">
        <label className="counter-label">
          No. of Child Seats{' '}
          <div>
            <span data-tip="Seats needed for passengers aged 2 to 11.">
              <IoInformationCircleSharp />
            </span>
            <ReactTooltip />
          </div>
        </label>
        <NumberAdjuster
          currentCounterValue={passengerDetails?.number_of_baby_seats ?? 0}
          updateCounter={updateCounter}
          minValue={0}
          maxValue={carDetails?.babySeats ?? 0}
          flag={`number_of_baby_seats`}
        />
      </div>

      <div className="counter-container">
        <label className="counter-label">
          No. of Infants{' '}
          <div>
            <span data-tip="Seats needed for passengers under 2 years.">
              <IoInformationCircleSharp />
            </span>
            <ReactTooltip />
          </div>
        </label>
        <NumberAdjuster
          currentCounterValue={passengerDetails?.number_of_infants ?? 0}
          updateCounter={updateCounter}
          minValue={0}
          maxValue={carDetails?.infants ?? 0}
          flag={`number_of_infants`}
        />
      </div>

      <div className="counter-container">
        <label className="counter-label">
          No. of Luggages{' '}
          <div>
            <span data-tip="Total number of bags, including cabin and checked.">
              <IoInformationCircleSharp />
            </span>
            <ReactTooltip />
          </div>
        </label>
        <NumberAdjuster
          currentCounterValue={passengerDetails?.number_of_luggages ?? 0}
          updateCounter={updateCounter}
          minValue={0}
          maxValue={carDetails?.luggages ?? 0}
          flag={`number_of_luggages`}
        />
      </div>
    </div>
  );
};

export default Counter;

const NumberAdjuster = ({
  currentCounterValue,
  updateCounter,
  minValue,
  maxValue,
  flag,
}: {
  currentCounterValue: number;
  updateCounter: any;
  minValue: number;
  maxValue: number;
  flag: string;
}) => {
  return (
    <div className="counter-main-section">
      <div
        className="counter-controller"
        onClick={() => {
          const updatedValue = currentCounterValue - 1;

          if (updatedValue >= minValue) {
            updateCounter(flag, updatedValue);
          }
        }}
      >
        <div className="counter-control">-</div>
      </div>
      <div className="counter-current-text">{currentCounterValue}</div>
      <div
        className="counter-controller"
        onClick={() => {
          const updatedValue = currentCounterValue + 1;

          if (updatedValue <= maxValue) {
            updateCounter(flag, updatedValue);
          }
        }}
      >
        <div className="counter-control" style={{ color: maxValue == currentCounterValue ? '#80808075' : '' }}>
          +
        </div>
      </div>
    </div>
  );
};
